// WhatsApp number - NÚMERO REAL
export const WHATSAPP_NUMBER = "5547997920909";
export const WHATSAPP_MESSAGE = "Olá, quero participar do desafio hexa no mar e queria tirar algumas dúvidas!";

// Copa 2026 - Data de início (11 de junho de 2026)
export const COPA_DATE = new Date('2026-06-11T00:00:00');

// Nomes para notificações de prova social
export const NOMES_COMPRADORES = [
  "Maria", "João", "Ana", "Pedro", "Carla", "Lucas", "Juliana", "Rafael", 
  "Fernanda", "Bruno", "Camila", "Diego", "Larissa", "Thiago", "Amanda",
  "Gustavo", "Beatriz", "Felipe", "Mariana", "Ricardo"
];

export const CIDADES = [
  "Florianópolis", "São Paulo", "Curitiba", "Porto Alegre", "Joinville",
  "Blumenau", "Balneário Camboriú", "Itajaí", "Brusque", "Rio de Janeiro",
  "Belo Horizonte", "Brasília", "Campinas", "Santos", "Criciúma"
];

// Vagas
export const TOTAL_VAGAS = 500;
export const VAGAS_OCUPADAS = 184;

// Instagram
export const INSTAGRAM_USERNAME = "divemastermergulho";

// Images - Usando fotos reais do passeio
export const IMAGES = {
  hero: "https://customer-assets.emergentagent.com/job_hexa-boat-tour/artifacts/g1enix7h_Design%20sem%20nome%20%2816%29.png",
  boat1: "https://customer-assets.emergentagent.com/job_hexa-boat-tour/artifacts/gh5ikuz0_4.png",
  boat2: "https://customer-assets.emergentagent.com/job_hexa-boat-tour/artifacts/g1enix7h_Design%20sem%20nome%20%2816%29.png",
  snorkeling1: "https://customer-assets.emergentagent.com/job_hexa-boat-tour/artifacts/w0usi3tw_Design%20sem%20nome%20%2811%29.png",
  snorkeling2: "https://customer-assets.emergentagent.com/job_hexa-boat-tour/artifacts/blurxdlq_Design%20sem%20nome%20%2812%29.png",
};

// Vídeo do passeio
export const VIDEO_PASSEIO = "https://customer-assets.emergentagent.com/job_hexa-boat-tour/artifacts/om1etxfe_video%20passeio%20%2B%20snorkel.MOV";

// Logo Dive Master
export const DIVE_MASTER_LOGO = "https://customer-assets.emergentagent.com/job_aposta-hexa-mar/artifacts/s4a9kcqd_LOGO%20NOVA%20DIVE%20MASTER.png";

// Caravela images
export const CARAVELA_IMAGES = [
  "https://customer-assets.emergentagent.com/job_4932539a-4a69-41ef-b514-bf7645b306e7/artifacts/e3qxjyzn_4.png",
  "https://customer-assets.emergentagent.com/job_4932539a-4a69-41ef-b514-bf7645b306e7/artifacts/l6l6ni9c_Design%20sem%20nome%20%2813%29.png",
  "https://customer-assets.emergentagent.com/job_4932539a-4a69-41ef-b514-bf7645b306e7/artifacts/v9bazu7h_Design%20sem%20nome%20%2815%29.png",
  "https://customer-assets.emergentagent.com/job_4932539a-4a69-41ef-b514-bf7645b306e7/artifacts/rrxxx7pg_Design%20sem%20nome%20%2818%29.png",
  "https://customer-assets.emergentagent.com/job_4932539a-4a69-41ef-b514-bf7645b306e7/artifacts/hznnd2yf_Design%20sem%20nome%20%2816%29.png",
  "https://customer-assets.emergentagent.com/job_4932539a-4a69-41ef-b514-bf7645b306e7/artifacts/tdmktfwn_Design%20sem%20nome%20%2817%29.png"
];

// Snorkeling images
export const SNORKELING_IMAGES = [
  "https://customer-assets.emergentagent.com/job_4932539a-4a69-41ef-b514-bf7645b306e7/artifacts/mi5xxp31_image.png",
  "https://customer-assets.emergentagent.com/job_4932539a-4a69-41ef-b514-bf7645b306e7/artifacts/wgtp168a_Design%20sem%20nome%20%2819%29.png",
  "https://customer-assets.emergentagent.com/job_4932539a-4a69-41ef-b514-bf7645b306e7/artifacts/516xiuam_Screenshot_20260319_210036_Gallery.jpg",
  "https://customer-assets.emergentagent.com/job_4932539a-4a69-41ef-b514-bf7645b306e7/artifacts/fj1senhz_Screenshot_20260319_210053_Gallery.jpg"
];

// Experience images
export const EXPERIENCE_IMAGES = [
  "https://customer-assets.emergentagent.com/job_4932539a-4a69-41ef-b514-bf7645b306e7/artifacts/e3qxjyzn_4.png",
  "https://customer-assets.emergentagent.com/job_4932539a-4a69-41ef-b514-bf7645b306e7/artifacts/mi5xxp31_image.png",
  "https://customer-assets.emergentagent.com/job_4932539a-4a69-41ef-b514-bf7645b306e7/artifacts/wgtp168a_Design%20sem%20nome%20%2819%29.png",
  "https://customer-assets.emergentagent.com/job_4932539a-4a69-41ef-b514-bf7645b306e7/artifacts/516xiuam_Screenshot_20260319_210036_Gallery.jpg",
  "https://customer-assets.emergentagent.com/job_4932539a-4a69-41ef-b514-bf7645b306e7/artifacts/fj1senhz_Screenshot_20260319_210053_Gallery.jpg",
  "https://customer-assets.emergentagent.com/job_4932539a-4a69-41ef-b514-bf7645b306e7/artifacts/tdmktfwn_Design%20sem%20nome%20%2817%29.png"
];

// WhatsApp Link Generator
export const getWhatsAppLink = (customMessage) => {
  const message = customMessage || WHATSAPP_MESSAGE;
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;
};

// FAQ Data
export const faqData = [
  {
    id: "faq-como-funciona",
    question: "Como funciona o Desafio do Hexa?",
    answer: "Antes de pagar, você escolhe seu palpite: Brasil GANHA ou NÃO GANHA a Copa. Se você acertar o resultado, você escolhe: recebe 100% do valor de volta OU traz mais uma pessoa para fazer o passeio de graça!"
  },
  {
    id: "faq-acertar",
    question: "E se eu acertar o palpite?",
    answer: "Você escolhe sua recompensa: receber 100% do valor pago de volta OU trazer mais uma pessoa para fazer o passeio totalmente grátis. O passeio é garantido de qualquer forma!"
  },
  {
    id: "faq-errar",
    question: "E se eu errar o palpite?",
    answer: "Você ainda fez ou vai fazer um dos passeios mais incríveis de Santa Catarina. Flutuação com snorkel, café da manhã a bordo e paisagens inesquecíveis!"
  },
  {
    id: "faq-agendar",
    question: "Como faço para agendar o passeio?",
    answer: "Após a compra, você recebe uma agenda virtual por WhatsApp para escolher a melhor data. Pode ser final de semana, feriado ou qualquer dia disponível — você decide quando quer viver essa experiência!"
  },
  {
    id: "faq-antes-depois",
    question: "Preciso fazer o passeio antes ou depois da Copa?",
    answer: "Você escolhe! Pode usar seu voucher antes OU depois da Copa, dentro de 12 meses. Seu direito de escolher a recompensa não muda."
  },
  {
    id: "faq-prazo",
    question: "Qual o prazo para usar o voucher?",
    answer: "O voucher tem validade de 12 meses a partir da data da compra."
  },
  {
    id: "faq-nadar",
    question: "Preciso saber nadar para fazer flutuação?",
    answer: "Não! Todos os participantes recebem uma roupa de neoprene que faz o corpo flutuar naturalmente. Qualquer pessoa consegue aproveitar."
  },
  {
    id: "faq-duracao",
    question: "Qual a duração do passeio?",
    answer: "O passeio tem duração de 3 a 4 horas, saindo de Porto Belo e passando por praias paradisíacas como Araçá e Caixa d'Aço."
  },
  {
    id: "faq-arrependimento",
    question: "E se eu me arrepender da compra?",
    answer: "Oferecemos garantia de 30 dias. Se você desistir antes de usar o voucher, devolvemos 100% do valor pago."
  },
  {
    id: "faq-preco",
    question: "Qual o valor do passeio?",
    answer: "O passeio custa R$97 por pessoa (de R$147). Você pode parcelar em até 12x de R$10,03 sem juros. O voucher vale por 12 meses."
  }
];

// Includes data
export const includesData = [
  { id: "inc-barco", icon: "Ship", title: "Passeio de Barco", desc: "3-4h na caravela" },
  { id: "inc-snorkel", icon: "Fish", title: "Snorkeling", desc: "Máscara, snorkel e nadadeira" },
  { id: "inc-neoprene", icon: "LifeBuoy", title: "Roupa Neoprene", desc: "Flutua naturalmente" },
  { id: "inc-banho", icon: "Waves", title: "Parada Banho", desc: "Melhor lugar para snorkel" },
  { id: "inc-cafe", icon: "Coffee", title: "Café da Manhã", desc: "A bordo do barco" },
  { id: "inc-sorteio", icon: "Gift", title: "Sorteio", desc: "Brindes todo passeio" },
  { id: "inc-validade", icon: "Calendar", title: "12 Meses", desc: "Para usar o voucher" },
  { id: "inc-hexa", icon: "Trophy", title: "Desafio Hexa", desc: "Acertou? Ganhou bônus!" }
];

// Caravela features
export const caravelaFeatures = [
  { id: "car-estavel", icon: "Ship", text: "Embarcação grande e estável" },
  { id: "car-banheiro", icon: "Bath", text: "Banheiro a bordo" },
  { id: "car-sombra", icon: "Umbrella", text: "Áreas com sombra" },
  { id: "car-espaco", icon: "Users", text: "Amplo espaço aberto" },
  { id: "car-vista", icon: "Eye", text: "Vista panorâmica" },
  { id: "car-fotos", icon: "Camera", text: "Cenário perfeito para fotos" }
];
